import customBaseQuery from "@lxp-app/utils/customBaseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { gql } from "graphql-request";

export const BulkUploadApi = createApi({
  reducerPath: "bulkUploadApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    bulkUploadOrRemoval: builder.mutation({
      query: ({ entityType, data }: { entityType: string; data: any }) => ({
        url: `/group/mcqQuestion/excelUpload/${entityType}/ADD`,
        method: "POST",
        body: data
      }),
      extraOptions: { service: "Resource" }
    }),
    GetUserInfoByUserId: builder.query({
      query: ({
        entityType,
        entityId,
        status,
        pageSize,
        pageNumber,
        searchKey,
        userId
      }: {
        entityType: string[] | string;
        entityId?: string;
        pageSize: number;
        pageNumber: number;
        searchKey: string | null;
        status?: string;
        userId: string;
      }) => ({
        url: "/graphql",
        body: gql`
          query GetExcelAuditElastic {
            getExcelAuditElastic(
              dtoRequest: {
                filters: { createdBy: "${userId}" ${entityId ? `entityId: "${entityId}"` : ""} entityType: ${JSON.stringify(entityType)}  ${status != undefined ? `status: "${status}"` : ""}}
                searchKey: ${searchKey === null ? null : `"${searchKey}"`}
                pagination: {
                  pageNumber: ${pageNumber}
                  pageSize: ${pageSize}
                  sortKey: "createdat"
                  sortOrder: "desc"
                }
              }
            ) {
              timestamp
              error
              version
              data {
                pageNumber
                pageSize
                totalCount
                searchResult {
                  id
                  type
                  filename
                  status
                  assetid
                  entityid
                  entitytype
                  validationerrors
                  insertederrors
                  validatedat
                  insertedat
                  totalrows
                  createdat
                  updatedat
                  createdby
                  updatedby
                  org
                  partialsavedata {
                    successCount
                    failedCount
                  }
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Resource" }
    })
  })
});

export const {
  useBulkUploadOrRemovalMutation,
  useGetUserInfoByUserIdQuery,
  useLazyGetUserInfoByUserIdQuery
} = BulkUploadApi;
